import React from 'react';

import { Auth as OriginalAuth } from '@sopranodesign/pulse-components';
import { usePulse } from '@sopranodesign/pulse-hooks';

const Auth = ({ children, ...props }) => {
  const { owner, versions } = usePulse();

  return (
    <OriginalAuth {...props} owner={owner} versions={versions}>
      {children}
    </OriginalAuth>
  );
};

export default Auth;
